<template>
  <CChartDoughnut
    :datasets="defaultDatasets"
    :labels="['Doctor', 'Ambulance', 'Pharmacy', 'Diagnostics', 'Blood Bank']"
  />
</template>

<script>
import { CChartDoughnut } from "@coreui/vue-chartjs";

export default {
  name: "CChartDoughnutExample",
  components: { CChartDoughnut },
  computed: {
    defaultDatasets() {
      return [
        {
          backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#DD1B16"],
          data: [45, 20, 15, 12]
        }
      ];
    }
  }
};
</script>
